export default __webpack_public_path__ + "static/media/sendfreight.6c768be4.jpg";